import React from 'react';
import ReactDOM from 'react-dom';
// import 'cookieconsent/build/cookieconsent.min.css'
// import 'cookieconsent/build/cookieconsent.min'
import "react-multi-carousel/lib/styles.css";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {delete_cookies_except} from "./scripts/cookie-helper";
import CONFIG from './temp/config';
import {NassauLog} from "./scripts/myga-utils";


function setDocHeight() {
  document.documentElement.style.setProperty('--vh', `${window.innerHeight/100}px`);
}
window.addEventListener('resize', setDocHeight);
window.addEventListener('orientationchange', setDocHeight);
setDocHeight();

if (!CONFIG.testing) {
  // 2024.11.18.ADivelbiss - original cookie consent, commenting in favor of new Osano account
  // window.cookieconsent.initialise({
  //   cookie: {
  //     name:'_cookieConsent',
  //     path:'/',
  //     domain:CONFIG.cookieDomain
  //   },
  //   content: {
  //     header: 'Cookies used on the website!',
  //     message: '<span>This website uses <a style="color: #ffffff; text-decoration: underline" href="https://nfg.com/privacy.html#cookies">cookies</a> to improve your browser experience. By continuing to use this site you agree to their use. We may also collect personal information about you.</span>',
  //     dismiss: '<img id="cookieDismissBtn" class="cle-x" />',
  //     allow: 'Allow cookies',
  //     deny: 'Decline',
  //     link: 'Learn more',
  //     href:'https://nfg.com/privacy.html#collectinfo',
  //     close: '<img class="cle-x" />',
  //     policy: 'Cookie Policy',
  //     target: '_blank'
  //   },
  //   palette:{
  //     popup: {background: "#005b9c"},
  //     button: {background: "#d9d9d9"},
  //   },
  //   onInitialise: function (status) {
  //     let didConsent = this.hasConsented();
  //     NassauLog('onInitialize: ' + (didConsent ? 'enable cookies' : 'disable cookies'));
  //     // if (didConsent) {
  //     //   window.dataLayer.push({'event':'cookie_consent_granted'});
  //     // }
  //   },
  //   onStatusChange: function(status) {
  //     let didConsent = this.hasConsented();
  //     NassauLog('onStatusChange: ' + (didConsent ? 'enable cookies' : 'disable cookies'));
  //     if (didConsent) {
  //       // dataLayer.push({'event':'cookie_consent_granted'});
  //     } else {
  //       delete_cookies_except(['_cookieConsent']);
  //     }
  //     window.dispatchEvent(new Event('cookie_status_change'));
  //   },
  //   onRevokeChoice: function() {
  //     NassauLog('onRevokeChoice: ' );
  //     // Disable cookies
  //     delete_cookies_except(['_cookieConsent']);
  //     window.location.reload();
  //   }
  // });
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
